type ClipboardFeature = 'clipboard-write' | 'clipboard-read';

const isAllowed = (feature: ClipboardFeature): boolean => {
  const policy = (document as any).permissionsPolicy || (document as any).featurePolicy;
  if (policy?.allowsFeature) return policy.allowsFeature(feature);
  return window.self === window.top;
};

const copyWithExecCommand = (value: string): boolean => {
  const host =
    (document.activeElement?.closest('[role="dialog"]') as HTMLElement | null) || document.body;
  const previousFocus = document.activeElement as HTMLElement | null;

  const field = document.createElement('textarea');
  field.value = value;
  field.setAttribute('readonly', '');
  field.className = 'clipboard-proxy';
  host.appendChild(field);
  field.focus();
  field.select();
  field.setSelectionRange(0, value.length);

  let ok = false;
  try {
    ok = document.execCommand('copy');
  } finally {
    host.removeChild(field);
    previousFocus?.focus?.();
  }
  return ok;
};

export const copyToClipboard = async (value: string): Promise<boolean> => {
  if (navigator.clipboard?.writeText && window.isSecureContext && isAllowed('clipboard-write')) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      return copyWithExecCommand(value);
    }
  }
  try {
    return copyWithExecCommand(value);
  } catch {
    return false;
  }
};

/** Returns null when the page may not read the clipboard (e.g. a restricted iframe). */
export const readClipboardText = async (): Promise<string | null> => {
  if (!navigator.clipboard?.readText || !isAllowed('clipboard-read')) return null;
  try {
    return await navigator.clipboard.readText();
  } catch {
    return null;
  }
};
